export default __webpack_public_path__ + "static/media/type_14_9.026beff2.svg";